import { action, makeObservable, observable } from 'mobx';

export class VerticalCourseTOCManager {
  constructor() {
    makeObservable(this);
  }

  @observable allowVerticalCourseTOC = false;

  @observable isLoadingVerticalCourseTOC = false;

  @observable isVerticalCourseTOCOpen = true;

  @observable verticalCourseTOCExpandedIds = new Set();

  @action setAllowVerticalCourseTOC = (toggle) => {
    this.allowVerticalCourseTOC = toggle;
  }

  @action setIsLoadingVerticalCourseTOC = (isLoading) => {
    this.isLoadingVerticalCourseTOC = isLoading;
  }

  @action setIsVerticalCourseTOCOpen = (open) => {
    this.isVerticalCourseTOCOpen = open;
  }

  @action toggleVerticalCourseTOCExpanded = (courseElementId) => {
    const isExpanded = this.verticalCourseTOCExpandedIds.has(courseElementId);
    if (isExpanded) {
      this.verticalCourseTOCExpandedIds.delete(courseElementId);
    } else {
      this.verticalCourseTOCExpandedIds.add(courseElementId);
    }
  }

  @action setVerticalCourseTOCExpandedIds = (courseElementIds) => {
    this.verticalCourseTOCExpandedIds = new Set(courseElementIds);
  }

  @action clearVerticalCourseTOCExpandedIds = () => {
    this.verticalCourseTOCExpandedIds.clear();
  }

  @action clearAll = () => {
    this.isVerticalCourseTOCOpen = true;
    this.verticalCourseTOCExpandedIds.clear();
  }
}

const verticalCourseTOCManager = new VerticalCourseTOCManager();

export default verticalCourseTOCManager;
